import { memo } from "react";
import { NotificationBadge } from "@/shared/components/NotificationBadge";
import { useAdminNotificationsContext } from "@/shared/contexts/AdminNotificationsProvider";

export const EcomOrderCounter = memo(() => {
  const { counts } = useAdminNotificationsContext();
  return <NotificationBadge count={counts.ecom_orders_pending} />;
});

EcomOrderCounter.displayName = "EcomOrderCounter";
